import axios from 'axios';
import { isFromCareConnect } from 'src/utils/url';
import { FronteggContext } from '@frontegg/rest-api';
import { useAuthStore } from 'src/hooks/auth';
import { useChatValidationStore } from 'src/hooks/chat';

export const getAccessToken = () => {
  if (isFromCareConnect()) {
    return FronteggContext.getAccessToken();
  } else {
    return useAuthStore.getState().token;
  }
};

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const fromCareConnect = isFromCareConnect();

  let token = getAccessToken();

  const chatToken = useChatValidationStore.getState().token;

  const headers = {
    Authorization: `Bearer ${token ? token : null}`,
    'From-Care-Connect': fromCareConnect,
    'Chat-URL': chatToken ? `/${chatToken}` : '/',
  };

  Object.entries(headers).forEach(([key, value]) => {
    if (!config.headers[key]) {
      config.headers[key] = value;
    }
  });

  return config;
});

api.defaults.headers.common = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
